"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teamsDarkTheme: function() {
        return _index.teamsDarkTheme;
    },
    teamsHighContrastTheme: function() {
        return _index.teamsHighContrastTheme;
    },
    teamsLightTheme: function() {
        return _index.teamsLightTheme;
    },
    webDarkTheme: function() {
        return _index.webDarkTheme;
    },
    webLightTheme: function() {
        return _index.webLightTheme;
    },
    createDarkTheme: function() {
        return _index1.createDarkTheme;
    },
    createHighContrastTheme: function() {
        return _index1.createHighContrastTheme;
    },
    createLightTheme: function() {
        return _index1.createLightTheme;
    },
    createTeamsDarkTheme: function() {
        return _index1.createTeamsDarkTheme;
    },
    themeToTokensObject: function() {
        return _themeToTokensObject.themeToTokensObject;
    },
    tokens: function() {
        return _tokens.tokens;
    },
    typographyStyles: function() {
        return _index2.typographyStyles;
    }
});
const _index = require("./themes/index");
const _index1 = require("./utils/index");
const _themeToTokensObject = require("./themeToTokensObject");
const _tokens = require("./tokens");
const _index2 = require("./global/index");
